import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  @Input() nomeComponente: string = 'default';
  @Input() tituloAccordion!: string;
  @Input() iconeAccordion!: string;
  @Input() camposInvalidos: boolean = false;
  @Input() estaAberto: boolean = false;

  @Output() aoClicar = new EventEmitter<void>();
  
  constructor() {}

  ngOnInit(): void {}

  alternarAccordion() {
    this.estaAberto = !this.estaAberto;
  }
}
